export const EventConstants = {
  POPULATE_EVENTS: 'LOAD_EVENTS_FROM_CHRONICLE',

  FETCH_EVENT_TYPES_REQUEST: 'FETCH_EVENT_TYPES_REQUEST',
  FETCH_EVENT_TYPES_SUCCESS: 'FETCH_EVENT_TYPES_SUCCESS',
  FETCH_EVENT_TYPES_FAILURE: 'FETCH_EVENT_TYPES_FAILURE',

  SAVE_NEW_EVENT_REQUEST: 'SAVE_NEW_EVENT_REQUEST',
  SAVE_NEW_EVENT_SUCCESS: 'SAVE_NEW_EVENT_SUCCESS',
  SAVE_NEW_EVENT_FAILURE: 'SAVE_NEW_EVENT_FAILURE',

  GET_CHRONICLE_EVENTS_REQUEST: 'GET_CHRONICLE_EVENTS_REQUEST',
  GET_CHRONICLE_EVENTS_SUCCESS: 'GET_CHRONICLE_EVENTS_SUCCESS',
  GET_CHRONICLE_EVENTS_FAILURE: 'GET_CHRONICLE_EVENTS_FAILURE',

  COPY_EVENT_REQUEST: 'COPY_EVENT_REQUEST',
  COPY_EVENT_SUCCESS: 'COPY_EVENT_SUCCESS',
  COPY_EVENT_FAILURE: 'COPY_EVENT_FAILURE',

  UPDATE_EVENT_REQUEST: 'UPDATE_EVENT_REQUEST',
  UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
  UPDATE_EVENT_FAILURE: 'UPDATE_EVENT_FAILURE',

  DELETE_EVENT_REQUEST: 'DELETE_EVENT_REQUEST',
  DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
  DELETE_EVENT_FAILURE: 'DELETE_EVENT_FAILURE',

  DELETE_MULTIPLE_EVENT_REQUEST: 'DELETE_MULTIPLE_EVENT_REQUEST',
  DELETE_MULTIPLE_EVENT_SUCCESS: 'DELETE_MULTIPLE_EVENT_SUCCESS',
  DELETE_MULTIPLE_EVENT_FAILURE: 'DELETE_MULTIPLE_EVENT_FAILURE',

  MOVE_EVENT_REQUEST: 'MOVE_EVENT_REQUEST',
  MOVE_EVENT_SUCCESS: 'MOVE_EVENT_SUCCESS',
  MOVE_EVENT_FAILURE: 'MOVE_EVENT_FAILURE',

  UPDATE_EVENTS_MAP_DELETE: 'UPDATE_EVENTS_ON_MAP_DELETE',
};
